module.exports = __webpack_public_path__ + "img/dealer.6bbe7b9c.png";